var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"title":("Raport organizacji pacjentów za rok " + _vm.reportYear)}},[_c('Organization')],1)}
var staticRenderFns = []

export { render, staticRenderFns }